// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"UserProductPanel_footerContainer__3R2G-","buttonMargin":"UserProductPanel_buttonMargin__2iMQs","saveButtonSpinner":"UserProductPanel_saveButtonSpinner__1GuSy"};